module.exports = __webpack_public_path__ + "static/media/witness_03.476bf20a.svg";